module.exports = __webpack_public_path__ + "static/media/whatsapp.dec08d54.svg";